import Model from "../Model";

class KpiclientrepresentantUser extends Model{

    buildUrl ({ param }) {
        return ['kpiemployeeclientview/getbyuserid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new KpiclientrepresentantUser;